import { useTheme } from '@emotion/react';
import cn from 'classnames';

import { IConDefaultType } from '../types';

interface ISupportIconProps extends IConDefaultType {}

function SupportIcon({ color, className, size = 24, rotate, flip }: ISupportIconProps) {
  const theme = useTheme();
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      <svg viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M15.2908 4.33074C14.3938 3.94654 13.4204 3.77378 12.4459 3.82582C11.4714 3.87785 10.5219 4.1533 9.67087 4.63085C8.81982 5.1084 8.08999 5.77527 7.5378 6.5799C6.98561 7.38453 6.62586 8.30537 6.48635 9.27122C6.95913 9.30759 7.33007 9.70763 7.33007 10.1786V15.6337C7.33007 16.1428 6.92094 16.5428 6.41544 16.5428H4.60254C3.87946 16.5428 3.18598 16.2557 2.67452 15.7446C2.16306 15.2335 1.87548 14.5402 1.875 13.8171L1.875 11.9988C1.875 11.2754 2.16236 10.5816 2.67388 10.0701C3.18539 9.55859 3.87915 9.27122 4.60254 9.27122H4.65345C4.87759 7.27139 5.8308 5.42428 7.3309 4.08291C8.831 2.74155 10.7728 2 12.7851 2C14.7975 2 16.7393 2.74155 18.2394 4.08291C19.7395 5.42428 20.6927 7.27139 20.9168 9.27122H20.9678C21.6911 9.27122 22.3849 9.55859 22.8964 10.0701C23.4079 10.5816 23.6953 11.2754 23.6953 11.9988V13.8171C23.6952 14.5071 23.4336 15.1713 22.9632 15.6761C22.4929 16.1809 21.8487 16.4886 21.1605 16.5374C20.995 17.7011 20.5441 18.6103 19.9149 19.3013C19.2771 19.9793 18.4727 20.4783 17.582 20.7487C17.1333 20.8925 16.6717 20.9924 16.2037 21.0469C16.0134 21.3985 15.7126 21.6777 15.3477 21.8411C14.9829 22.0045 14.5743 22.0432 14.1853 21.9511C13.7963 21.8589 13.4485 21.6411 13.1957 21.3314C12.9429 21.0217 12.7992 20.6373 12.7869 20.2377C12.7745 19.8381 12.8943 19.4456 13.1275 19.1209C13.3607 18.7962 13.6944 18.5574 14.0771 18.4414C14.4597 18.3255 14.8698 18.3389 15.2441 18.4795C15.6183 18.6202 15.9357 18.8802 16.1473 19.2195C16.4451 19.1765 16.7389 19.109 17.0256 19.0176C17.6092 18.8285 18.1566 18.5321 18.5712 18.0739C18.9578 17.6439 19.2161 17.1141 19.3167 16.5447H19.153C18.9119 16.5437 18.6808 16.4477 18.5099 16.2775C18.339 16.1073 18.2421 15.8766 18.2402 15.6355V10.1804C18.2402 9.69308 18.613 9.30759 19.0839 9.27304C18.9283 8.1932 18.4977 7.1715 17.8335 6.30602C17.1693 5.44054 16.2937 4.76035 15.2908 4.33074Z"
          fill={color || theme.color.icon.icon_4}
        />
      </svg>
    </i>
  );
}

export default SupportIcon;
